import { Component } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd, NavigationStart } from '@angular/router';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';
import { SmtpConfigurationService } from './service/smtp-configuration/smtp-configuration.service';
import { Title } from '@angular/platform-browser';
import { LocalstorageService } from './service/shared/localstorage/localstorage.service';
import { AngularFireStorage } from '@angular/fire/storage';
import { ToolsService } from './service/tools/tools.service';
import { PermissionsService } from './service/auth/permissions.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'egan-hub-web';
  showSideNav = false;
  showHeader = false;
  configurationArr = {};
  isLogin = true;
  isResetPassword = true;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private smtpConfigurationService: SmtpConfigurationService,
    private titleService: Title,
    private localStorageService: LocalstorageService,
    private storage: AngularFireStorage,
    private toolsService: ToolsService,
    private permissionsService: PermissionsService,
  ) {}

  ngOnInit() {
    this.getSmtpConfiguration();
    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        let url = this.router.url.split('?')[0];
        if (url == '/' || url == '' || url == undefined) {
          this.showSideNav = false;
          this.showHeader = false;
          this.isResetPassword = false;
          this.isLogin = true;
        } else if (url == '/reset-password') {
          this.showSideNav = false;
          this.showHeader = false;
          this.isResetPassword = true;
        } else {
          this.isLogin = false;
          this.showSideNav = true;
          this.showHeader = true;
          this.isResetPassword = false;
        }

        if (!['/tools', '/tools/models', '/tools/transfers', '/tools/inventory'].includes(url)) {
          this.toolsService.setCountShouldBeVisible(false);
        } else {
          this.toolsService.setCountShouldBeVisible(true);
        }

        const user = this.localStorageService.getItem('user');

        if (!this.isResetPassword && !this.isLogin) this.permissionsService.refresh();

        if (user && user != null && user != undefined) {
          this.isLogin = false;
        } else {
          if (!this.isResetPassword) {
            this.router.navigateByUrl('/');
            this.isLogin = true;
          }
        }
      }
    });
  }

  getSmtpConfiguration() {
    this.smtpConfigurationService.getSiteConfiguration().subscribe(
      res => this.onSmtpSuccess(res),
      error => this.onSmtpError(error),
    );
  }

  onSmtpSuccess(result) {
    if (result) {
      if (result.data) {
        result.data.forEach(element => {
          this.configurationArr[element.config_item] = element.config_value;
          if (element.config_item == 'egan_hub_primary_color') {
            document.documentElement.style.setProperty('--primary-color', element.config_value);
          }
          if (element.config_item == 'egan_hub_site_title') {
            this.titleService.setTitle(element.config_value);
          }
          if (element.config_item == 'egan_hub_favicon') {
            if (element.config_value != '') {
              setTimeout(() => {
                let siteLogo = this.storage.ref('uploads/site_logo/' + element.config_value);
                siteLogo.getDownloadURL().subscribe(url => {
                  if (url) {
                    document.getElementById('appSiteFavicon').setAttribute('href', url);
                  }
                });
              }, 300);
            }
          }
        });
      }
    }
  }

  onSmtpError(error) {}

}
